import type { ResumeSectionType } from '@applicator/shared'
import { Loader2, Sparkles } from 'lucide-react'

import { Button } from '../../Button'
import {
  SECTION_FEEDBACK_CALLOUT_CLASS,
  SECTION_FEEDBACK_LIST_CLASS,
  SECTION_FEEDBACK_TITLE_CLASS,
} from './sectionFeedbackCallout'

interface SectionQualityFeedbackProps {
  sectionType: ResumeSectionType
  recommendations: string[]
  onRegenerateWithFeedback?: () => void
  regenerating?: boolean
  showRegenerateButton?: boolean
}

export default function SectionQualityFeedback({
  sectionType,
  recommendations,
  onRegenerateWithFeedback,
  regenerating = false,
  showRegenerateButton = false,
}: SectionQualityFeedbackProps) {
  if (!recommendations.length) return null

  const canRegenerate = Boolean(showRegenerateButton && onRegenerateWithFeedback)

  return (
    <div
      data-section-quality-feedback={sectionType}
      data-testid="section-quality-feedback"
      className={SECTION_FEEDBACK_CALLOUT_CLASS}
    >
      <div className="mb-1.5 flex flex-wrap items-center justify-between gap-2">
        <p className={SECTION_FEEDBACK_TITLE_CLASS}>What to fix</p>
        {canRegenerate && (
          <Button
            type="button"
            variant="outline"
            className="h-8 gap-1.5 border-amber-300 bg-white/80 px-2.5 text-xs text-amber-950 hover:bg-amber-100"
            data-testid="section-regenerate-with-feedback"
            disabled={regenerating}
            onClick={onRegenerateWithFeedback}
          >
            {regenerating ? (
              <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />
            ) : (
              <Sparkles className="h-3.5 w-3.5" aria-hidden />
            )}
            <span>{regenerating ? 'Regenerating…' : 'Regenerate with feedback'}</span>
          </Button>
        )}
      </div>
      <ul className={SECTION_FEEDBACK_LIST_CLASS}>
        {recommendations.map((rec, index) => (
          <li key={`${index}-${rec}`} className="text-xs sm:text-sm">
            {rec}
          </li>
        ))}
      </ul>
    </div>
  )
}
